import FormQuestion from '@components/membership/form-question/FormQuestion'
import Page from '@components/Page/Page'
import { FormQuestion as FormQuestionModel } from '@models/membership/Form'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getFormQuestions,
  selectFormQuestions,
  setFormQuestionQuery,
} from '@store/membership/FormQuestionReducer'
import { selectSelectedProgram } from '@store/membership/ProgramReducer'
import { extractSortDataFromSorterResult } from '@supplement-bacon/react-toolkit/utils'
import {
  initialQuery,
  SBTable,
  TableParams,
} from '@supplement-bacon/sb-table-filters'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { TablePaginationConfig } from 'antd'
import { FilterValue, SorterResult } from 'antd/es/table/interface'
import { useEffect } from 'react'

const FormQuestionsTab = () => {
  const program = useAppSelector(selectSelectedProgram())

  const dispatch = useAppDispatch()
  const formQuestions = useAppSelector(selectFormQuestions())
  const { query, isLoading } = useAppSelector((state) => state.formQuestion)

  const columns: TableColumnsType<FormQuestionModel> = [
    {
      title: 'Questions',
      render: (record: FormQuestionModel) => (
        <FormQuestion.Avatar model={record} />
      ),
    },
  ]

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<FormQuestionModel> | SorterResult<FormQuestionModel>[]
  ) => {
    const newQuery = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setFormQuestionQuery(newQuery))
    dispatch(getFormQuestions(newQuery))
  }

  const fetchFormQuestion = () => {
    const query: TableParams = {
      ...initialQuery,
      columnKey: 'questions',
      order: 'ascend',
      filters: {
        programs: [program?.id ?? 0],
      },
    }
    dispatch(setFormQuestionQuery(query))
    dispatch(getFormQuestions(query))
  }

  useEffect(() => {
    if (!program) return

    fetchFormQuestion()
  }, [program])

  if (!program) {
    return <></>
  }

  return (
    <Page permissions={Permission.manageProgramsMembership}>
      <SBTable
        columns={columns}
        dataSource={formQuestions}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        showSorterTooltip={{ target: 'sorter-icon' }}
      />
    </Page>
  )
}

export default FormQuestionsTab
